import React, {Component, Fragment} from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardTitle,
    Col,
    Input,
    Label,
    Row,
} from "reactstrap";
import {Link} from "react-router-dom";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {actionDeleteUserById, actionGetAgentsByRoll} from "../../actions/profile";
import {PAGE_TITLE} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";

class PageTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData: true,
            q: '',
            offset: '',
            limit: '',
            searchValue: '',
            errors: {},
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = "Page Title | Prime Private Network";
        const request = {
            q: this.state.q,
            offset: this.state.offset,
            limit: this.state.limit
        };
        this.props.actionGetAgentsByRoll(request);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.agentsByRoll !== this.props.agentsByRoll) {
            this.setState({allUsers: this.props.agentsByRoll});
        }
    }

    render() {
        const columns = [
            {
                name: "Page Name",
                selector: "name",
                sortable: true,
                center: true
            },
            {
                name: "Page Title",
                selector: "email",
                sortable: true,
                center: true
            },
            {
                name: "Page Description",
                selector: "mobile",
                sortable: true,
                center: true
            },
            {
                name: "",
                selector: "_id",
                sortable: true,
                right: true,
                cell: row => <div className="d-flex align-items-center user-list-icon">
                    {/* <Link to={`view-user/${row._id}`}
                          className="mx-1 text-dark"
                    ><i className="fa fa-info fa-lg"/></Link>*/}
                    <Link to={`update-user/${row._id}`} className="mx-1 text-dark">
                        <i className="fa fa-edit fa-lg"/>
                    </Link>
                    {/*<Link className="mr-1 text-dark" to={'/users'} onClick={() =>
                        swal({
                            title: 'Are you sure you want to delete this User?',
                            text: "Once deleted, you will not be able to recover this User!",
                            icon: "warning",
                            buttons: true,
                            dangerMode: true,
                        })
                            .then((willDelete) => {
                                if (willDelete) {
                                    swal("Poof! User has been deleted!", {
                                        icon: "success",

                                    });
                                    this.props.actionDeleteUserById(row._id);

                                }
                            })
                    }><i className="fa fa-trash fa-lg"/></Link>*/}
                </div>
            }
        ];

        return (
            <Fragment>
                <Navbar scenario={PAGE_TITLE}/>
                <HeroSection title={'Page Title'}/>
                <Card className="w-75 mx-auto mt-5">
                    <CardHeader
                        className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                        <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                            <CardTitle tag='h4'>Page Title & Description</CardTitle>
                            <Link to="/add-page">
                                <Button className='ml-2'>
                                    <i className="fa fa-plus"/>
                                    <span className='align-middle ml-50'>Add New Page</span>
                                </Button>
                            </Link>
                        </div>
                    </CardHeader>
                    <Row className='justify-content-end mx-0'>
                        <Col className='d-flex align-items-center justify-content-end mt-1' lg="3" md='3' sm='12'>
                            <Label className='mr-1' for='search-input'>
                                Search
                            </Label>
                            <Input
                                className='dataTable-filter mb-50 '
                                type='text'
                                // bsSize='sm'
                                id='search-input'
                                // value={searchValue}
                                // onChange={this.handleFilter}
                                onChange={(e) => {
                                    let newFilterText = e.target.value;
                                    const agents = this.props.agentsByRoll.filter(
                                        (item) =>
                                            (item.name &&
                                                item.name.toLowerCase().includes(newFilterText.toLowerCase()))
                                    );
                                    this.setState({searchValue: newFilterText, allUsers: agents});
                                }}

                                //onClear={this.handleClear}
                                value={this.state.searchValue}
                            />
                        </Col>
                    </Row>
                    <DataTable
                        noHeader
                        pagination
                        columns={columns}
                        paginationPerPage={7}
                        className='react-dataTable'
                        //sortIcon={<Icon.ChevronDown size={10}/>}
                        // paginationDefaultPage={currentPage + 1}
                        // paginationComponent={this.CustomPagination}
                        data={this.state.allUsers && this.state.allUsers}
                        // selectableRowsComponent={BootstrapCheckbox}
                    />
                    {this.props.agentsLoader && <div className="text-center">Loading...</div>}
                </Card>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    agentsByRoll: state.profile.agentsByRoll,
    agentsLoader: state.profile.agentsLoader,
    user: state.auth.user
});


export default connect(mapStateToProps, {actionGetAgentsByRoll, actionDeleteUserById})(PageTitle);